// extracted by mini-css-extract-plugin
module.exports = {"AuditRecordList":"DetailedAuditTable_AuditRecordList__3cfUn"};